import { get } from '@kit/utils/APIV1.js'

export const page = async() => {
  return get(`fbicc-careers`)
}

export const jobPost = async(id) => {
  return get(`job-post/id/${id}`)
}